import React from 'react';
import { LinearProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  progressBar: {
    backgroundColor: theme.palette.admin.light,
  },
  progressBarColor: {
    backgroundColor: theme.palette.admin.main,
  },
  progressBarLoading: {
    margin: '50px auto 50px',
  },
}));
const AdminProgressBar = ({ style }) => {
  const classes = useStyles();
  return (
    <LinearProgress
      className={classes.progressBarLoading}
      classes={{ colorPrimary: classes.progressBar, barColorPrimary: classes.progressBarColor }}
      style={style}
    />
  );
};

export default AdminProgressBar;
